/* eslint-disable import/prefer-default-export */
import { ConsentType } from "../types/consent";
import { clientHttpInstance } from "./http-client";

export type GetConsentsByCodeRes = {
  data: ConsentType;
};

/**
 *get all consents by lang
 * @param code consent code
 * @param lang consent language
 * @returns consents
 */
export const getConsentsByCode = async (
  code: string,
  lang: string
): Promise<ConsentType> => {
  const res = await clientHttpInstance.get<GetConsentsByCodeRes>(
    `/consent/${code}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
  return res.data.data;
};
